/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';
import { ActivityView } from './activity-view';

const ICON_PATH = '/utest-static/assets/images/activity';

// One row of the "My Activity" feed: icon or avatar, title, time, and a sentence linking to the item.
@Component({
  selector: 'ut-activity-item',
  standalone: true,
  imports: [UIRouterModule, SharedModule, EmojiHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './activity-item.component.html',
  styleUrls: ['./activity-item.component.scss'],
})
export class ActivityItemComponent {
  @Input({ required: true }) view: ActivityView;
  @Input() unread = false;

  readonly iconPath = ICON_PATH;
}
